import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { STATIC_STRINGS } from "@asez/shared";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import MoreVert from "@mui/icons-material/MoreVert";
import { Menu , MenuItem } from "@mui/material";

const RenderTable = ({
  searchTerm,
  data,
  setFetchOptions,
  updateAssessmentId,
}: any) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [menuPosition, setMenuPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);
  const filteredData = searchTerm.trim() === "" 
  ? data 
  : data?.filter((name) => {
      if (!name?.name) return false;

      const lowerCaseName = name.name.toLowerCase().trim();
      const searchWords = searchTerm.toLowerCase().trim().split(/\s+/);

      return searchWords.every((word) => lowerCaseName.includes(word));
    });

  const handleMenuClick = (event: React.MouseEvent, id: string) => {
    const rect = (
      event.currentTarget as HTMLButtonElement
    ).getBoundingClientRect();
    setMenuPosition({
      top: rect.bottom,
      left: rect.right,
    });
    setSelectedId(id);
  };

  const handleMenuClose = () => {
    setMenuPosition(null);
    setSelectedId(null);
  };

  const getStatusClass = (status: string) => {
      if(status === "ADMIN") return "active";
      return "paused";
    };

  return (
    <TableContainer sx={{ maxHeight: "calc(100vh - 400px)" }}>
      <Table stickyHeader>
        <TableHead
          sx={{
            backgroundColor: "var(--color-table-header)",
            "& .MuiTableCell-head": {
              backgroundColor: "var(--color-table-header)",
            },
          }}
        >
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>
              {STATIC_STRINGS.SETTING_PAGE_TABLE_HEADERS.FIRST_TABLE_DIVISON}
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }}>
              {STATIC_STRINGS.SETTING_PAGE_TABLE_HEADERS.SECOND_TABLE_DIVISON}
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }}>
              {STATIC_STRINGS.SETTING_PAGE_TABLE_HEADERS.THIRD_TABLE_DIVISON}
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }}>
              {STATIC_STRINGS.SETTING_PAGE_TABLE_HEADERS.FOURTH_TABLE_DIVISON}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, width: "20px" }}>
              {STATIC_STRINGS.SETTING_PAGE_TABLE_HEADERS.FIFTH_TABLE_DIVISON}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.map((assessment, idx) => (
            <TableRow key={assessment.id}>
              <TableCell
                sx={{
                  borderBottom: idx == filteredData.length - 1 ? "none" : "",
                }}
              >
                {assessment.name}
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: idx == filteredData.length - 1 ? "none" : "",
                }}
              >
                {assessment.email}
              </TableCell>
              <TableCell>
                <span className={getStatusClass(assessment.role)}>
                  {assessment.role}
                </span>
              </TableCell>
              <TableCell>{assessment.status}</TableCell>
              <TableCell>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMenuClick(e, assessment.id);
                  }}
                >
                  <MoreVert />
                </IconButton>
                {selectedId === assessment.id && (
                  <Menu
                    open={!!menuPosition}
                    anchorReference="anchorPosition"
                    anchorPosition={menuPosition ?? { top: 0, left: 0 }}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    onClose={(e: Event) => {
                      e.stopPropagation();
                      handleMenuClose();
                    }}
                  >
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {STATIC_STRINGS.MENU_ITEMS.EDIT}
                    </MenuItem>
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {STATIC_STRINGS.MENU_ITEMS.DELETE_MEMBER}
                    </MenuItem>
                  </Menu>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RenderTable;
